// JavaScript Document
//components/dashboard/Dashboard
import logo from '../../logo.png';
//import '../../App.css';
import React from 'react';
import useWebSocket from 'react-use-websocket';
import { Button } from '@material-ui/core';

const WS_URL = process.env.WEBSOCKET_URL;



export default function RTSocket() {
    const {
        //sendMessage,
        sendJsonMessage,
        //lastMessage,
        //lastJsonMessage,
        //readyState,
        //getWebSocket
    } = useWebSocket(WS_URL, {
        onOpen : () => {
            console.log('WebSocket connection established.');
        },
        shouldReconnect: (closeEvent) => true,
        onMessage: (e) => {
            console.log('message', e);
        },
        share: true,
    });

    const sendUpdate = (e) => {
        var msg = {sign : 10, action: 'doit'};
        sendJsonMessage(msg);
        console.log('sent', msg);
    }
	
  return (
    <div>
	        <header className="App-header">
        	  <img src={logo} className="App-logo" alt="logo" />
              <Button color="primary" variant="contained" onClick={sendUpdate} >Test Me</Button>
        	  <p>
                Websockets? <br />
          		VSpeed™Online 2.0
        	  </p>
      		</header>
    </div>
  );
}
